import React from 'react'

import Breadcrumb from 'components/Breadcrumb'
import ContainerWithArrowsBg from 'components/ContainerWithArrowsBg'
import { Container } from 'components/Grid'
import Seo from 'components/Layout/components/Seo'
import HomeLayout from 'components/Layout/Home'
import OneTapScript from 'components/OneTapScript'
import TrustBanner from 'components/TrustBanner'
import { useAppContext } from 'context/AppContext'
import { useUser } from 'hooks'
import { ROUTE_NAMES } from 'routes'
import routeService from 'services/routes'

import { ArticlesContextProvider } from './ArticlesProvider'
import ContentHubs from './components/ContentHubs'
import FilterByTopic from './components/FilterByTopic'
import ResourcesSearch from './components/ResourcesSearch'
import { ResultContextProvider } from './ResultsProvider'

import classes from './Home.module.scss'

const Resources = ({ topics, posts, contentHubs }) => {
  const breadcrumbItems = [
    {
      name: 'Blog & research',
      path: routeService.generatePath(ROUTE_NAMES.RESOURCES),
    },
  ]
  const { url } = useAppContext()
  const [user] = useUser()

  return (
    <>
      <OneTapScript user={user} />
      <Seo
        title="Blog & Research | GetApp"
        description="Discover the latest small business trends and tools in GetApp's blog and research - featuring articles and videos to help guide you and your business."
        route={{ name: ROUTE_NAMES.RESOURCES }}
        url={url}
      ></Seo>
      <ContainerWithArrowsBg>
        <Breadcrumb structuredDataItems={breadcrumbItems}>
          <Breadcrumb.Item
            action="go-to_resource_homepage"
            isDisabled
            href={routeService.generatePath(ROUTE_NAMES.RESOURCES)}
          >
            Blog & research
          </Breadcrumb.Item>
        </Breadcrumb>
        <Container className={classes.trustBannerContainer}>
          <TrustBanner />
        </Container>
        <Container className={classes.container}>
          <h1 className={classes.homepageHeadline}>Blog & research</h1>
          <ArticlesContextProvider initialPosts={posts}>
            <div className={classes.autocompleteContainer}>
              <ResultContextProvider>
                <ResourcesSearch />
              </ResultContextProvider>
            </div>
            <FilterByTopic topics={topics} />
          </ArticlesContextProvider>
          {contentHubs && <ContentHubs contentHubs={contentHubs} />}
        </Container>
      </ContainerWithArrowsBg>
    </>
  )
}

Resources.Layout = HomeLayout

export default Resources
